window.Calculator = function () {
    var el = this;
    var template = $('#calculator-template').html();

    el.price = {};
    el.priceGroupId = 0;
    el.propertyTypes = {};
    el.properties = {};
    el.currency = {};
    el.data = {};
    el.cost = 0;
    
    el.getFormatCost = function (formatId) {
        var cost = 0;
        var price = el.price[el.priceGroupId][el.project.current.product_id];
        
        var typeId;
        for (typeId in el.data) {
            if (el.propertyTypes.hasOwnProperty(typeId)) {
                cost += parseFloat(price[el.data[typeId]][formatId]);
            }
        }

        var propertyId;
        for (propertyId in price) {
            if (propertyId === '0') {
                cost += parseFloat(price[propertyId][formatId]);
            }
        }

        return cost;
    };

    el.init = function () {
        el.data = el.project.current.calculator;

        var typeId, type, propertyId, property;
        var price = el.price[el.priceGroupId][el.project.current.product_id];
        var workareaId, workarea, isCanSet;

        // проверка сущестует ли сохраненное свойство и его цены
        for (typeId in el.propertyTypes) {
            type = el.propertyTypes[typeId];

            for (workareaId in el.workData.workareas) {
                workarea = el.workData.workareas[workareaId];

                if (
                        el.data.hasOwnProperty(typeId)
                        && (!el.properties.hasOwnProperty(el.data[typeId])
                                || !price.hasOwnProperty(el.data[typeId])
                                || !price[el.data[typeId]].hasOwnProperty(workarea.format_id)
                                )
                        ) {
                    delete el.data[typeId];
                }
            }
        }

        // если в проекте не указаны свойства продукта, то ставим по умолчанию

        for (typeId in el.propertyTypes) {
            type = el.propertyTypes[typeId];

            if (el.data.hasOwnProperty(typeId)) {
                continue;
            }

            for (propertyId in el.properties) {
                property = el.properties[propertyId];

                if (property.property_type_id !== typeId) {
                    continue;
                }

                if (!price.hasOwnProperty(propertyId)) {
                    console.log('Внимание! Не указана цена - ' + property.name);
                    continue;
                }

                isCanSet = true;

                for (workareaId in el.workData.workareas) {
                    workarea = el.workData.workareas[workareaId];

                    if (!price[propertyId].hasOwnProperty(workarea.format_id)) {
                        console.log('Внимание! Не указана цена - ' + property.name + ' - ' + el.format.items[workarea.format_id].name);
                        isCanSet = false;
                        break;
                    }
                }

                if (isCanSet) {
                    el.data[typeId] = propertyId;
                    break;
                }
            }
        }

        el.calcCost();
        el.render();
    };

    el.get = function () {
        return el.data;
    };

    el.calcCost = function () {
        el.cost = 0;

        var price = el.price[el.priceGroupId][el.project.current.product_id];

        var i, workarea;
        for (i in el.workData.workareas) {
            workarea = el.workData.workareas[i];

            var typeId;
            for (typeId in el.data) {
                if (el.propertyTypes.hasOwnProperty(typeId)) {
                    el.cost += parseFloat(price[el.data[typeId]][workarea.format_id]);
                }
            }

            var propertyId;
            for (propertyId in price) {
                if (propertyId === '0') {
                    el.cost += parseFloat(price[propertyId][workarea.format_id]);
                }
            }
        }

        el.setCost();
    };

    el.setCost = function () {
        $('.cost').text(el.cost.toFixed(2));
    };

    el.render = function () {
        var templateData = {
            cost: el.cost,
            currency: el.currency,
            types: [],
            product_name: el.currentProduct.company.name ? el.currentProduct.company.name : el.currentProduct.default.name,
            format_name: el.format.current.name
        };

        var propertyId, typeId, property;
        var price = el.price[el.priceGroupId][el.project.current.product_id];
        var templateType, templateProperty;
        var workareaId, workarea, isCanSet, cost;
        var isShowCalculator = false;

        for (typeId in el.data) {

            if (el.propertyTypes.hasOwnProperty(typeId)) {
                templateType = {
                    id: typeId,
                    name: el.propertyTypes[typeId].name,
                    properties: []
                };

                for (propertyId in el.properties) {
                    property = el.properties[propertyId];

                    if (property.property_type_id !== typeId) {
                        continue;
                    }

                    if (!price.hasOwnProperty(propertyId)) {
                        console.log('Внимание! Не указана цена - ' + property.name);
                        continue;
                    }

                    cost = 0;
                    isCanSet = true;

                    for (workareaId in el.workData.workareas) {
                        workarea = el.workData.workareas[workareaId];

                        if (!price[propertyId].hasOwnProperty(workarea.format_id)) {
                            isCanSet = false;
                            console.log('Внимание! Не указана цена - ' + property.name + ' - ' + el.format.items[workarea.format_id].name);
                            break;
                        }
                        
                        cost += parseFloat(price[propertyId][workarea.format_id]);
                    }

                    if (isCanSet) {
                        isShowCalculator = true;
                        
                        templateProperty = {
                            id: property.id,
                            type_id: typeId,
                            name: property.name,
                            cost: cost.toFixed(2),
                            is_icon: property.icon !== 0 ? true : false,
                            is_active: property.id === el.data[typeId] ? true : false
                        };

                        templateType.properties.push(templateProperty);
                    }
                }

            }

            templateData.types.push(templateType);
        }

        var html = el.templater.render(template, templateData);
        $('#calculator').html(html);
        
        if (isShowCalculator) {
            $('#page-step-constructor .js-step-calculator').removeClass('hide');
            $('#page-step-constructor .js-step-shopcart').addClass('hide');
        } else {
            $('#page-step-constructor .js-step-shopcart').removeClass('hide');
            $('#page-step-constructor .js-step-calculator').addClass('hide');
        }
    };

    el.set = function () {
        var id = $(this).attr('data-id');
        var typeId = el.properties[id].property_type_id;
        el.data[typeId] = id;

        el.calcCost();
        el.render();
    };

    $(document).on('click', '.js-set-property', el.set);
};